// Generated by Avo VERSION 239.15.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Staging = "staging",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "fIj4H3QmGZutJmToGNkg";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "swTCCeEOMd1DUDSnqWjZ",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "64J0Mrx44bp9vyfV_Na2P",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "swTCCeEOMd1DUDSnqWjZ",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "64J0Mrx44bp9vyfV_Na2P",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "JmwsgKTQe50MTmUE9FVs",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface Products {
  productId: string | null | undefined
  category: string | null | undefined
  itemCategory2: string | null | undefined
  itemCategory3: string | null | undefined
  itemCategory4: string | null | undefined
  itemCategory5: string | null | undefined
  affiliation: AffiliationValueType | null | undefined
  itemListName: ItemListNameValueType | null | undefined
  variant: string | null | undefined
  price: number | null | undefined
  quantity: number | null | undefined
  currency: CurrencyValueType | null | undefined
  position: number | null | undefined
  imageUrl: string | null | undefined
  onlineMaterial: string | null | undefined
  fitId: string | null | undefined
  plpGridImages: string | null | undefined
  shopTheLookId: string | null | undefined
  mixAndMatch: MixAndMatchValueType | null | undefined
  productSetId: string | null | undefined
  listId: string | null | undefined
  sku: string | null | undefined
  fullLook: string | null | undefined
  value: number | null | undefined
  customSize: boolean | null | undefined
  includedAlterations: boolean | null | undefined
  hasSizepassport: boolean | null | undefined
  outOfStock: boolean | null | undefined
  sliderImageNumber: number | null | undefined
  hasImageSliderInteraction: boolean | null | undefined
  isCmLite: boolean | null | undefined
  cmLiteFabricAvailable: boolean
  cmLiteFit: CmLiteFitValueType | null | undefined
  cmLiteVariantFit: CmLiteVariantFitValueType | null | undefined
  deliveryDays: string | null | undefined
  hasUsedSizepassport: boolean | null | undefined
  sizePassportFitBucket: string | null | undefined
  brand: BrandValueType | null | undefined
  name: string | null | undefined
  shopifyProductId: string | null | undefined
  productHandle: string | null | undefined
  productTitle: string | null | undefined
  productType: string | null | undefined
  variantId: string | null | undefined
  variantTitle: string | null | undefined
  coupon: string | null | undefined
  discount: number | null | undefined
}

export interface CommunicationPreferences {
  newsletterStatus: boolean | null | undefined
}

export const CmLiteFit = {
  'SLIM': 'slim',
  'STRAIGHT': 'straight',
  'WIDE': 'wide',
} as const;
export type CmLiteFitType = typeof CmLiteFit;
export type CmLiteFitValueType = CmLiteFitType[keyof CmLiteFitType];

export const MixAndMatch = {
  'TRUE': 'true',
  'FALSE': 'false',
} as const;
export type MixAndMatchType = typeof MixAndMatch;
export type MixAndMatchValueType = MixAndMatchType[keyof MixAndMatchType];

export const Tab = {
  'ORDERS': 'Orders',
  'OVERVIEW': 'Overview',
  'SETTINGS': 'Settings',
  'SIZE_PASSPORT': 'Size Passport',
  'WISHLIST': 'Wishlist',
} as const;
export type TabType = typeof Tab;
export type TabValueType = TabType[keyof TabType];

export const ItemListName = {
  'CUSTOM_MADE_LITE': 'custom made lite',
} as const;
export type ItemListNameType = typeof ItemListName;
export type ItemListNameValueType = ItemListNameType[keyof ItemListNameType];

export const AddressFields = {
  'ADDRESS_LINE_1': 'Address line 1',
  'CITY': 'City',
  'COUNTRY': 'Country',
  'ZIP_CODE': 'Zip code',
} as const;
export type AddressFieldsType = typeof AddressFields;
export type AddressFieldsValueType = AddressFieldsType[keyof AddressFieldsType];

export const LoggedIn = {
  'FALSE': 'false',
  'TRUE': 'true',
} as const;
export type LoggedInType = typeof LoggedIn;
export type LoggedInValueType = LoggedInType[keyof LoggedInType];

export const AddressType = {
  'BILLING': 'Billing',
  'SHIPPING': 'Shipping',
} as const;
export type AddressTypeType = typeof AddressType;
export type AddressTypeValueType = AddressTypeType[keyof AddressTypeType];

export const LoginSource = {
  'LOGIN_NUDGE': 'login_nudge',
  'SIZE_PASSPORT_TAB': 'size_passport_tab',
  'WISHLIST_SAVE': 'wishlist_save',
} as const;
export type LoginSourceType = typeof LoginSource;
export type LoginSourceValueType = LoginSourceType[keyof LoginSourceType];

export const EventCategory = {
  'CHECKOUT_INTERACTIONS': 'checkout_interactions',
  'PLP_INTERACTIONS': 'plp_interactions',
  'PDP_INTERACTIONS': 'pdp_interactions',
  'GLOBAL_INTERACTIONS': 'global_interactions',
  'FOOTER_INTERACTIONS': 'footer_interactions',
  'JOURNAL_INTERACTIONS': 'journal_interactions',
  'CM_INTERACTIONS': 'cm_interactions',
  'LOOKBUILDER_INTERACTIONS': 'lookbuilder_interactions',
  'INSTORE_INTERACTIONS': 'instore_interactions',
  'ECOMMERCE_INTERACTIONS': 'ecommerce_interactions',
  'BTC_INTERACTIONS': 'btc_interactions',
  'BOOKING_INTERACTIONS': 'booking_interactions',
  'LOGIN_INTERACTIONS': 'login_interactions',
  'SP_INTERACTIONS': 'sp_interactions',
  'CONFIGURATOR_INTERACTIONS': 'configurator_interactions',
  'RETURNING_ITEM_INTERACTIONS': 'returning_item_interactions',
} as const;
export type EventCategoryType = typeof EventCategory;
export type EventCategoryValueType = EventCategoryType[keyof EventCategoryType];

export const Language = {
  'DE': 'de',
  'EN': 'en',
  'ES': 'es',
  'FR': 'fr',
  'IT': 'it',
  'KO': 'ko',
  'NL': 'nl',
  'PL': 'pl',
  'SV': 'sv',
  'ZH': 'zh',
} as const;
export type LanguageType = typeof Language;
export type LanguageValueType = LanguageType[keyof LanguageType];

export const PageType = {
  'ACCOUNT': 'account',
  'BLACK_TIE_CONFIGURATOR': 'black-tie-configurator',
  'BLACK_TIE_CONFIGURATOR': 'black_tie_configurator',
  'BOOKING_TOOL': 'booking_tool',
  'CART': 'cart',
  'CATEGORY': 'category',
  'CATEGORY_LANDING': 'category_landing',
  'CHECKOUT': 'checkout',
  'CUSTOMMADE': 'custommade',
  'EMPLOYEE_PROFILE': 'employee_profile',
  'ERROR': 'error',
  'GIFTCARD': 'giftcard',
  'HOME': 'home',
  'INSTORE': 'instore',
  'JOURNAL': 'journal',
  'LOGIN': 'login',
  'LOOKBUILDER': 'lookbuilder',
  'MINI_CART': 'mini-cart',
  'ORDER_CONFIRMATION': 'order_confirmation',
  'PRODUCT': 'product',
  'PRODUCT_DETAIL_PAGE': 'product_detail_page',
  'PRODUCT_LIST_PAGE': 'product_list_page',
  'RETURN': 'return',
  'RETURN_CONFIRMATION': 'return_confirmation',
  'STORE': 'store',
  'STORE_DETAILS': 'store_details',
  'STORE_LOCATOR': 'store_locator',
  'STORE_OVERVIEW': 'store_overview',
  'SUPPORT': 'support',
  'WISHLIST': 'wishlist',
  'OTHER': 'other',
  'CONFIGURATOR': 'configurator',
  'LANDING': 'landing',
  'SEARCH': 'search',
  'ALREADY_CHECKED_IN': 'already_checked_in',
  'ALREADY_CHECKED_OUT': 'already_checked_out',
  'CUSTOMER_HUB': 'customer_hub',
  'CUSTOMER_SEARCH': 'customer_search',
  'CUSTOMERS_IN_STORE': 'customers_in_store',
  'LOGGED_IN': 'logged_in',
  'PREFERENCE_CENTER': 'preference_center',
  'REGISTER': 'register',
} as const;
export type PageTypeType = typeof PageType;
export type PageTypeValueType = PageTypeType[keyof PageTypeType];

export const UserType = {
  'CUSTOMER': 'Customer',
  'STYLE_ADVISOR': 'Style Advisor',
} as const;
export type UserTypeType = typeof UserType;
export type UserTypeValueType = UserTypeType[keyof UserTypeType];

export const CmLiteVariantFit = {
  'STRAIGHT': 'straight',
  'TAPERED': 'tapered',
} as const;
export type CmLiteVariantFitType = typeof CmLiteVariantFit;
export type CmLiteVariantFitValueType = CmLiteVariantFitType[keyof CmLiteVariantFitType];

export const Affiliation = {
  'WEBSTORE_EUR': 'webstore-eur',
  'WEBSTORE_USD': 'webstore-usd',
  'WEBSTORE_CAD': 'webstore-cad',
  'WEBSTORE_PLN': 'webstore-pln',
  'WEBSTORE_AUD': 'webstore-aud',
  'WEBSTORE_SEK': 'webstore-sek',
  'WEBSTORE_CHF': 'webstore-chf',
  'WEBSTORE_DKK': 'webstore-dkk',
  'WEBSTORE_AED': 'webstore-aed',
  'WEBSTORE_NOK': 'webstore-nok',
  'WEBSTORE_CNY': 'webstore-cny',
  'WEBSTORE_SGD': 'webstore-sgd',
  'WEBSTORE_HKD': 'webstore-hkd',
  'WEBSTORE_GBP': 'webstore-gbp',
  'WEBSTORE_KRW': 'webstore-krw',
} as const;
export type AffiliationType = typeof Affiliation;
export type AffiliationValueType = AffiliationType[keyof AffiliationType];

export const Brand = {
  'SUITSUPPLY': 'suitsupply',
} as const;
export type BrandType = typeof Brand;
export type BrandValueType = BrandType[keyof BrandType];

export const Rating = {
  'BAD': 'bad',
  'GOOD': 'good',
} as const;
export type RatingType = typeof Rating;
export type RatingValueType = RatingType[keyof RatingType];

export const Country = {
  'AE': 'ae',
  'AT': 'at',
  'AU': 'au',
  'BE': 'be',
  'BG': 'bg',
  'BN': 'bn',
  'CA': 'ca',
  'CH': 'ch',
  'CN': 'cn',
  'CY': 'cy',
  'CZ': 'cz',
  'DE': 'de',
  'DK': 'dk',
  'DO': 'do',
  'EE': 'ee',
  'ES': 'es',
  'FI': 'fi',
  'FR': 'fr',
  'GB': 'gb',
  'GH': 'gh',
  'GI': 'gi',
  'GP': 'gp',
  'GR': 'gr',
  'GW': 'gw',
  'HK': 'hk',
  'HR': 'hr',
  'HU': 'hu',
  'IE': 'ie',
  'IN': 'in',
  'IR': 'ir',
  'IS': 'is',
  'IT': 'it',
  'JE': 'je',
  'JP': 'jp',
  'KR': 'kr',
  'LI': 'li',
  'LT': 'lt',
  'LU': 'lu',
  'LV': 'lv',
  'LY': 'ly',
  'MC': 'mc',
  'MO': 'mo',
  'MQ': 'mq',
  'MT': 'mt',
  'MV': 'mv',
  'MY': 'my',
  'NL': 'nl',
  'NO': 'no',
  'PL': 'pl',
  'PR': 'pr',
  'PT': 'pt',
  'QA': 'qa',
  'RO': 'ro',
  'SE': 'se',
  'SG': 'sg',
  'SI': 'si',
  'SK': 'sk',
  'TT': 'tt',
  'US': 'us',
} as const;
export type CountryType = typeof Country;
export type CountryValueType = CountryType[keyof CountryType];

export const Currency = {
  'EUR': 'eur',
  'USD': 'usd',
  'CNY': 'cny',
  'AUD': 'aud',
  'BGN': 'bgn',
  'CAD': 'cad',
  'CZK': 'czk',
  'DKK': 'dkk',
  'HKD': 'hkd',
  'HUF': 'huf',
  'ISK': 'isk',
  'INR': 'inr',
  'JPY': 'jpy',
  'CHF': 'chf',
  'MOP': 'mop',
  'MYR': 'myr',
  'NOK': 'nok',
  'QAR': 'qar',
  'RON': 'ron',
  'SGD': 'sgd',
  'SEK': 'sek',
  'AED': 'aed',
  'GBP': 'gbp',
  'PLN': 'pln',
  'KRW': 'krw',
} as const;
export type CurrencyType = typeof Currency;
export type CurrencyValueType = CurrencyType[keyof CurrencyType];

export const CardType = {
  'ALTERATION': 'Alteration',
  'ORDER': 'Order',
} as const;
export type CardTypeType = typeof CardType;
export type CardTypeValueType = CardTypeType[keyof CardTypeType];

export const ApplicationId = {
  'CUSTOMER_HUB': 'customer_hub',
} as const;
export type ApplicationIdType = typeof ApplicationId;
export type ApplicationIdValueType = ApplicationIdType[keyof ApplicationIdType];

let sysApplicationId: any;
let sysVersion: any;
let sysAffiliateMarker: any;
let sysAwc: any;
let sysCountry: any;
let sysLanguage: any;
let sysLocationId: any;
let sysUserId: any;
let sysLoggedIn: any;
let sysPageType: any;
let sysGaClientId: any;
let sysGaSessionId: any;
let sysGaSessionNumber: any;
let sysFbFbp: any;
let sysFbFbc: any;
let sysGaAwClid: any;
let sysTtclid: any;
let sysMsclkid: any;
let sysTwclid: any;
let sysRdtCid: any;
let sysEpik: any;

export function setSystemProperties(properties: {applicationId: ApplicationIdValueType;
    version: string;
    affiliateMarker: string | null | undefined;
    awc: string | null | undefined;
    country: CountryValueType;
    language: LanguageValueType;
    locationId: string;
    userId: string;
    loggedIn: LoggedInValueType;
    pageType: PageTypeValueType;
    gaClientId: string;
    gaSessionId: string;
    gaSessionNumber: string;
    fbFbp: string | null | undefined;
    fbFbc: string | null | undefined;
    gaAwClid: string | null | undefined;
    ttclid: string | null | undefined;
    msclkid: string | null | undefined;
    twclid: string | null | undefined;
    rdtCid: string | null | undefined;
    epik: string | null | undefined}) {
  if (properties.applicationId !== null && properties.applicationId !== undefined) {
    sysApplicationId = properties.applicationId;
  }
  if (properties.version !== null && properties.version !== undefined) {
    sysVersion = properties.version;
  }
  if (properties.affiliateMarker !== null && properties.affiliateMarker !== undefined) {
    sysAffiliateMarker = properties.affiliateMarker;
  }
  if (properties.awc !== null && properties.awc !== undefined) {
    sysAwc = properties.awc;
  }
  if (properties.country !== null && properties.country !== undefined) {
    sysCountry = properties.country;
  }
  if (properties.language !== null && properties.language !== undefined) {
    sysLanguage = properties.language;
  }
  if (properties.locationId !== null && properties.locationId !== undefined) {
    sysLocationId = properties.locationId;
  }
  if (properties.userId !== null && properties.userId !== undefined) {
    sysUserId = properties.userId;
  }
  if (properties.loggedIn !== null && properties.loggedIn !== undefined) {
    sysLoggedIn = properties.loggedIn;
  }
  if (properties.pageType !== null && properties.pageType !== undefined) {
    sysPageType = properties.pageType;
  }
  if (properties.gaClientId !== null && properties.gaClientId !== undefined) {
    sysGaClientId = properties.gaClientId;
  }
  if (properties.gaSessionId !== null && properties.gaSessionId !== undefined) {
    sysGaSessionId = properties.gaSessionId;
  }
  if (properties.gaSessionNumber !== null && properties.gaSessionNumber !== undefined) {
    sysGaSessionNumber = properties.gaSessionNumber;
  }
  if (properties.fbFbp !== null && properties.fbFbp !== undefined) {
    sysFbFbp = properties.fbFbp;
  }
  if (properties.fbFbc !== null && properties.fbFbc !== undefined) {
    sysFbFbc = properties.fbFbc;
  }
  if (properties.gaAwClid !== null && properties.gaAwClid !== undefined) {
    sysGaAwClid = properties.gaAwClid;
  }
  if (properties.ttclid !== null && properties.ttclid !== undefined) {
    sysTtclid = properties.ttclid;
  }
  if (properties.msclkid !== null && properties.msclkid !== undefined) {
    sysMsclkid = properties.msclkid;
  }
  if (properties.twclid !== null && properties.twclid !== undefined) {
    sysTwclid = properties.twclid;
  }
  if (properties.rdtCid !== null && properties.rdtCid !== undefined) {
    sysRdtCid = properties.rdtCid;
  }
  if (properties.epik !== null && properties.epik !== undefined) {
    sysEpik = properties.epik;
  }
}

let Segment: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {applicationId: ApplicationIdValueType;
    version: string;
    affiliateMarker: string | null | undefined;
    awc: string | null | undefined;
    country: CountryValueType;
    language: LanguageValueType;
    locationId: string;
    userId: string;
    loggedIn: LoggedInValueType;
    pageType: PageTypeValueType;
    gaClientId: string;
    gaSessionId: string;
    gaSessionNumber: string;
    fbFbp: string | null | undefined;
    fbFbc: string | null | undefined;
    gaAwClid: string | null | undefined;
    ttclid: string | null | undefined;
    msclkid: string | null | undefined;
    twclid: string | null | undefined;
    rdtCid: string | null | undefined;
    epik: string | null | undefined},
    destinationOptions: any,
    SegmentDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  setSystemProperties(systemProperties);
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    if (__AVO_ENV__ === AvoEnv.Staging) {
    }
    
    Segment = SegmentDestination;
    if (__AVO_ENV__ === 'prod') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, "4OhwIsrqFzQ0aeuYev8muGSWiimGtGIG");
    } else if (__AVO_ENV__ === 'dev') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    } else {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertPrice(price: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertFloat("5RMsvPEmT", _label ? "price" + ': ' + _label : "price", price));
  messages = messages.concat(AvoAssert.assertMin("5RMsvPEmT", _label ? "price" + ": " + _label : "price", 0.000000, price));
  return messages;
}

function assertPriceOptional(price: number | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (price !== undefined && price !== null) {
    messages = messages.concat(AvoAssert.assertFloat("5RMsvPEmT", _label ? "price" + ': ' + _label : "price", price));
    messages = messages.concat(AvoAssert.assertMin("5RMsvPEmT", _label ? "price" + ": " + _label : "price", 0.000000, price));
  }
  return messages;
}

function assertValue(value: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertFloat("Kddfsr3Xx", _label ? "value" + ': ' + _label : "value", value));
  messages = messages.concat(AvoAssert.assertMin("Kddfsr3Xx", _label ? "value" + ": " + _label : "value", 0.000000, value));
  return messages;
}

function assertValueOptional(value: number | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (value !== undefined && value !== null) {
    messages = messages.concat(AvoAssert.assertFloat("Kddfsr3Xx", _label ? "value" + ': ' + _label : "value", value));
    messages = messages.concat(AvoAssert.assertMin("Kddfsr3Xx", _label ? "value" + ": " + _label : "value", 0.000000, value));
  }
  return messages;
}

function assertQuantity(quantity: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertInt("fg1kaNXr_", _label ? "quantity" + ': ' + _label : "quantity", quantity));
  messages = messages.concat(AvoAssert.assertMin("fg1kaNXr_", _label ? "quantity" + ": " + _label : "quantity", 1, quantity));
  return messages;
}

function assertQuantityOptional(quantity: number | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (quantity !== undefined && quantity !== null) {
    messages = messages.concat(AvoAssert.assertInt("fg1kaNXr_", _label ? "quantity" + ': ' + _label : "quantity", quantity));
    messages = messages.concat(AvoAssert.assertMin("fg1kaNXr_", _label ? "quantity" + ": " + _label : "quantity", 1, quantity));
  }
  return messages;
}

function assertPosition(position: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertInt("pBPbnpdFj", _label ? "position" + ': ' + _label : "position", position));
  messages = messages.concat(AvoAssert.assertMin("pBPbnpdFj", _label ? "position" + ": " + _label : "position", 1, position));
  return messages;
}

function assertPositionOptional(position: number | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (position !== undefined && position !== null) {
    messages = messages.concat(AvoAssert.assertInt("pBPbnpdFj", _label ? "position" + ': ' + _label : "position", position));
    messages = messages.concat(AvoAssert.assertMin("pBPbnpdFj", _label ? "position" + ": " + _label : "position", 1, position));
  }
  return messages;
}

function assertProductsOptional(products: Products[] | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (products !== undefined && products !== null) {
    messages = messages.concat(AvoAssert.assertList("rg6ssTw5D", "products", products));
    products.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("rg6ssTw5D", "item at index " + index + " in products", value));
      messages = messages.concat(assertPriceOptional(value.price, "item at index " + index + " in products"));
      messages = messages.concat(assertQuantityOptional(value.quantity, "item at index " + index + " in products"));
      messages = messages.concat(assertPositionOptional(value.position, "item at index " + index + " in products"));
      messages = messages.concat(assertValueOptional(value.value, "item at index " + index + " in products"));
    });
  }
  return messages;
}

function assertCommunicationPreferences(communicationPreferences: CommunicationPreferences,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertObject("sDlh7c0yvS7a0T6AcoGcQ", _label ? "communication_preferences" + ': ' + _label : "communication_preferences", communicationPreferences));
  if (communicationPreferences !== null && communicationPreferences !== undefined) {
  }
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface ProductListViewedProperties {
  listId: string;
  itemListName: ItemListNameValueType;
  products: Products[] | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * Product List Viewed: This event represents a list of items presented to the user. It includes the list_id, which identifies the item list, as well as the list name. Additionally, it contains an object that encompasses all products displayed to the user.
 * 
 * When to trigger this event:
 * 1. Wishlist: when the saved items are shown in the Customer Hub Wishlist tab, online or in store (item_list_name = wishlist, list_id = customer_hub_wishlist, products = the saved items shown, each with its saved size).
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/syjGhZU5cD/trigger/g9hROn5fIpNkTkifcDu9p
 * 
 * @param properties the properties associated with this event
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * @param properties.products: An array of products needed for the specific event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/syjGhZU5cD}
 */
export function productListViewed(properties: ProductListViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  properties.products !== undefined && properties.products !== null ?
    eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: properties.products.map(function(value) { return {
        "product_id": value.productId,
        "category": value.category,
        "item_category2": value.itemCategory2,
        "item_category3": value.itemCategory3,
        "item_category4": value.itemCategory4,
        "item_category5": value.itemCategory5,
        "affiliation": value.affiliation,
        "item_list_name": value.itemListName,
        "variant": value.variant,
        "price": value.price,
        "quantity": value.quantity,
        "currency": value.currency,
        "position": value.position,
        "image_url": value.imageUrl,
        "online_material": value.onlineMaterial,
        "fit_id": value.fitId,
        "plp_grid_images": value.plpGridImages,
        "shop_the_look_id": value.shopTheLookId,
        "mix_and_match": value.mixAndMatch,
        "product_set_id": value.productSetId,
        "list_id": value.listId,
        "sku": value.sku,
        "full_look": value.fullLook,
        "value": value.value,
        "custom_size": value.customSize,
        "included_alterations": value.includedAlterations,
        "has_sizepassport": value.hasSizepassport,
        "out_of_stock": value.outOfStock,
        "slider_image_number": value.sliderImageNumber,
        "has_image_slider_interaction": value.hasImageSliderInteraction,
        "is_cm_lite": value.isCmLite,
        "cm_lite_fabric_available": value.cmLiteFabricAvailable,
        "cm_lite_fit": value.cmLiteFit,
        "cm_lite_variant_fit": value.cmLiteVariantFit,
        "delivery_days": value.deliveryDays,
        "has_used_sizepassport": value.hasUsedSizepassport,
        "size_passport_fit_bucket": value.sizePassportFitBucket,
        "brand": value.brand,
        "name": value.name,
        "shopify_product_id": value.shopifyProductId,
        "product_handle": value.productHandle,
        "product_title": value.productTitle,
        "product_type": value.productType,
        "variant_id": value.variantId,
        "variant_title": value.variantTitle,
        "coupon": value.coupon,
        "discount": value.discount,
      }
    })}) :
    eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertProductsOptional(properties.products));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "syjGhZU5cD", "a91e9199e136f0a5c6d50a6930bf22f089a19ea6fa10a38bf7541d5a50b691c0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product List Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("syjGhZU5cD", "Product List Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product List Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product List Viewed", eventProperties, "syjGhZU5cD", "a91e9199e136f0a5c6d50a6930bf22f089a19ea6fa10a38bf7541d5a50b691c0");
    }
    // destination Segment
    Segment.logEvent("Product List Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductListViewedSimilarProductsProperties {
  products: Products[] | null | undefined;
  currency: CurrencyValueType | null | undefined;
  eventLocation: string;
  itemListName: ItemListNameValueType;
}
/**
 * Product List Viewed: This event represents a list of items presented to the user. It includes the list_id, which identifies the item list, as well as the list name. Additionally, it contains an object that encompasses all products displayed to the user., event variant
 * 
 * When to trigger this event:
 * 1. When the "Similar products" list is shown
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/syjGhZU5cD.wSIdD0UWx/trigger/uCUQTq1a0b4
 * 2. When the "Similar products" list is shown
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/syjGhZU5cD.wSIdD0UWx/trigger/6WiyLpXsBF7
 * 
 * @param properties the properties associated with this event
 * @param properties.products: An array of products needed for the specific event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/syjGhZU5cD.wSIdD0UWx}
 */
export function productListViewedSimilarProducts(properties: ProductListViewedSimilarProductsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.products !== undefined && properties.products !== null ?
    eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: properties.products.map(function(value) { return {
        "product_id": value.productId,
        "category": value.category,
        "item_category2": value.itemCategory2,
        "item_category3": value.itemCategory3,
        "item_category4": value.itemCategory4,
        "item_category5": value.itemCategory5,
        "affiliation": value.affiliation,
        "item_list_name": value.itemListName,
        "variant": value.variant,
        "price": value.price,
        "quantity": value.quantity,
        "currency": value.currency,
        "position": value.position,
        "image_url": value.imageUrl,
        "online_material": value.onlineMaterial,
        "fit_id": value.fitId,
        "plp_grid_images": value.plpGridImages,
        "shop_the_look_id": value.shopTheLookId,
        "mix_and_match": value.mixAndMatch,
        "product_set_id": value.productSetId,
        "list_id": value.listId,
        "sku": value.sku,
        "full_look": value.fullLook,
        "value": value.value,
        "custom_size": value.customSize,
        "included_alterations": value.includedAlterations,
        "has_sizepassport": value.hasSizepassport,
        "out_of_stock": value.outOfStock,
        "slider_image_number": value.sliderImageNumber,
        "has_image_slider_interaction": value.hasImageSliderInteraction,
        "is_cm_lite": value.isCmLite,
        "cm_lite_fabric_available": value.cmLiteFabricAvailable,
        "cm_lite_fit": value.cmLiteFit,
        "cm_lite_variant_fit": value.cmLiteVariantFit,
        "delivery_days": value.deliveryDays,
        "has_used_sizepassport": value.hasUsedSizepassport,
        "size_passport_fit_bucket": value.sizePassportFitBucket,
        "brand": value.brand,
        "name": value.name,
        "shopify_product_id": value.shopifyProductId,
        "product_handle": value.productHandle,
        "product_title": value.productTitle,
        "product_type": value.productType,
        "variant_id": value.variantId,
        "variant_title": value.variantTitle,
        "coupon": value.coupon,
        "discount": value.discount,
      }
    })}) :
    eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "ecommerce_interactions"});
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: "similar_products"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertProductsOptional(properties.products));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "syjGhZU5cD.wSIdD0UWx", "271762d161e2a78d287a1d813e4f1d7b76d90bbe94f49f44ddcfaa2a55b50d78", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product List Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("syjGhZU5cD.wSIdD0UWx", "Product List Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product List Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product List Viewed", eventProperties, "syjGhZU5cD.wSIdD0UWx", "271762d161e2a78d287a1d813e4f1d7b76d90bbe94f49f44ddcfaa2a55b50d78");
    }
    // destination Segment
    Segment.logEvent("Product List Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductListViewedNoMinussearchMinusresultMinuspageProperties {
  listId: string;
  itemListName: ItemListNameValueType;
  products: Products[] | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * Product List Viewed: This event represents a list of items presented to the user. It includes the list_id, which identifies the item list, as well as the list name. Additionally, it contains an object that encompasses all products displayed to the user.variant description: This event will track products shown on the no search result page
 * 
 * When to trigger this event:
 * 1. Trigger a product list viewed event for the products shown on the no search result page. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/syjGhZU5cD.7-U7eVQEvRxD_1JBjstdy/trigger/t3j5Pu2v8h2r4TWfgBiHM
 * 
 * @param properties the properties associated with this event
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * @param properties.products: An array of products needed for the specific event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/syjGhZU5cD.7-U7eVQEvRxD_1JBjstdy}
 */
export function productListViewedNoSearchResultPage(properties: ProductListViewedNoMinussearchMinusresultMinuspageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  properties.products !== undefined && properties.products !== null ?
    eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: properties.products.map(function(value) { return {
        "product_id": value.productId,
        "category": value.category,
        "item_category2": value.itemCategory2,
        "item_category3": value.itemCategory3,
        "item_category4": value.itemCategory4,
        "item_category5": value.itemCategory5,
        "affiliation": value.affiliation,
        "item_list_name": value.itemListName,
        "variant": value.variant,
        "price": value.price,
        "quantity": value.quantity,
        "currency": value.currency,
        "position": value.position,
        "image_url": value.imageUrl,
        "online_material": value.onlineMaterial,
        "fit_id": value.fitId,
        "plp_grid_images": value.plpGridImages,
        "shop_the_look_id": value.shopTheLookId,
        "mix_and_match": value.mixAndMatch,
        "product_set_id": value.productSetId,
        "list_id": value.listId,
        "sku": value.sku,
        "full_look": value.fullLook,
        "value": value.value,
        "custom_size": value.customSize,
        "included_alterations": value.includedAlterations,
        "has_sizepassport": value.hasSizepassport,
        "out_of_stock": value.outOfStock,
        "slider_image_number": value.sliderImageNumber,
        "has_image_slider_interaction": value.hasImageSliderInteraction,
        "is_cm_lite": value.isCmLite,
        "cm_lite_fabric_available": value.cmLiteFabricAvailable,
        "cm_lite_fit": value.cmLiteFit,
        "cm_lite_variant_fit": value.cmLiteVariantFit,
        "delivery_days": value.deliveryDays,
        "has_used_sizepassport": value.hasUsedSizepassport,
        "size_passport_fit_bucket": value.sizePassportFitBucket,
        "brand": value.brand,
        "name": value.name,
        "shopify_product_id": value.shopifyProductId,
        "product_handle": value.productHandle,
        "product_title": value.productTitle,
        "product_type": value.productType,
        "variant_id": value.variantId,
        "variant_title": value.variantTitle,
        "coupon": value.coupon,
        "discount": value.discount,
      }
    })}) :
    eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertProductsOptional(properties.products));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "syjGhZU5cD.7-U7eVQEvRxD_1JBjstdy", "4c679e6c50d9fbdd639ac7ed3e10e3fdcc20637fb08c511d7c0cde20f6cd8342", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product List Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("syjGhZU5cD.7-U7eVQEvRxD_1JBjstdy", "Product List Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product List Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product List Viewed", eventProperties, "syjGhZU5cD.7-U7eVQEvRxD_1JBjstdy", "4c679e6c50d9fbdd639ac7ed3e10e3fdcc20637fb08c511d7c0cde20f6cd8342");
    }
    // destination Segment
    Segment.logEvent("Product List Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductListViewedCustomMinusmadeMinusliteProperties {
  listId: string;
  products: Products[] | null | undefined;
  currency: CurrencyValueType | null | undefined;
  flowId: string | null | undefined;
  cmLiteEntryProductId: string | null | undefined;
  itemListName: ItemListNameValueType;
}
/**
 * Product List Viewed: This event represents a list of items presented to the user. It includes the list_id, which identifies the item list, as well as the list name. Additionally, it contains an object that encompasses all products displayed to the user.variant description: This product list viewed is triggered when the user clicks "Choose fit" and sees the custom made lite panel in the PDP. 
 * The item_list_name should be "custom made lite"
 * The list_id should be the Product Id from the PDP
 * products array should contain all RTW products that can be selected as a fit for this product with corresponding RTW codes in product_id
 * 
 * When to trigger this event:
 * 1. When the Select fit panel is opened
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/syjGhZU5cD.goZfhYvb9QgaAOs8EDaoN/trigger/56XpWg11hlhGhgW8rdGX6
 * 
 * @param properties the properties associated with this event
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.products: An array of products needed for the specific event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.cmLiteEntryProductId: Product code of the PDP where the customer opened the CM Lite panel (product A). The added or selected product (product B) is in product_id.
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/syjGhZU5cD.goZfhYvb9QgaAOs8EDaoN}
 */
export function productListViewedCustomMadeLite(properties: ProductListViewedCustomMinusmadeMinusliteProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  properties.products !== undefined && properties.products !== null ?
    eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: properties.products.map(function(value) { return {
        "product_id": value.productId,
        "category": value.category,
        "item_category2": value.itemCategory2,
        "item_category3": value.itemCategory3,
        "item_category4": value.itemCategory4,
        "item_category5": value.itemCategory5,
        "affiliation": value.affiliation,
        "item_list_name": value.itemListName,
        "variant": value.variant,
        "price": value.price,
        "quantity": value.quantity,
        "currency": value.currency,
        "position": value.position,
        "image_url": value.imageUrl,
        "online_material": value.onlineMaterial,
        "fit_id": value.fitId,
        "plp_grid_images": value.plpGridImages,
        "shop_the_look_id": value.shopTheLookId,
        "mix_and_match": value.mixAndMatch,
        "product_set_id": value.productSetId,
        "list_id": value.listId,
        "sku": value.sku,
        "full_look": value.fullLook,
        "value": value.value,
        "custom_size": value.customSize,
        "included_alterations": value.includedAlterations,
        "has_sizepassport": value.hasSizepassport,
        "out_of_stock": value.outOfStock,
        "slider_image_number": value.sliderImageNumber,
        "has_image_slider_interaction": value.hasImageSliderInteraction,
        "is_cm_lite": value.isCmLite,
        "cm_lite_fabric_available": value.cmLiteFabricAvailable,
        "cm_lite_fit": value.cmLiteFit,
        "cm_lite_variant_fit": value.cmLiteVariantFit,
        "delivery_days": value.deliveryDays,
        "has_used_sizepassport": value.hasUsedSizepassport,
        "size_passport_fit_bucket": value.sizePassportFitBucket,
        "brand": value.brand,
        "name": value.name,
        "shopify_product_id": value.shopifyProductId,
        "product_handle": value.productHandle,
        "product_title": value.productTitle,
        "product_type": value.productType,
        "variant_id": value.variantId,
        "variant_title": value.variantTitle,
        "coupon": value.coupon,
        "discount": value.discount,
      }
    })}) :
    eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  properties.flowId !== undefined && properties.flowId !== null ?
    eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId}) :
    eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: null});
  properties.cmLiteEntryProductId !== undefined && properties.cmLiteEntryProductId !== null ?
    eventPropertiesArray.push({id: "A86OnAXSov5v_E1q05wXn", name: "cm_lite_entry_product_id", value: properties.cmLiteEntryProductId}) :
    eventPropertiesArray.push({id: "A86OnAXSov5v_E1q05wXn", name: "cm_lite_entry_product_id", value: null});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertProductsOptional(properties.products));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "syjGhZU5cD.goZfhYvb9QgaAOs8EDaoN", "9c5fc1be72f35b2dc8719cfb3b35ed9cc69d2b19bad23eaa7bc899864d489535", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product List Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("syjGhZU5cD.goZfhYvb9QgaAOs8EDaoN", "Product List Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product List Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product List Viewed", eventProperties, "syjGhZU5cD.goZfhYvb9QgaAOs8EDaoN", "9c5fc1be72f35b2dc8719cfb3b35ed9cc69d2b19bad23eaa7bc899864d489535");
    }
    // destination Segment
    Segment.logEvent("Product List Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductClickedProperties {
  listId: string;
  itemListName: ItemListNameValueType;
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string | null | undefined;
  variant: string;
  price: number;
  quantity: number;
  position: number;
  imageUrl: string;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  plpGridImages: string;
  shopTheLookId: string;
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
  sliderImageNumber: number;
  hasImageSliderInteraction: boolean;
  includedAlterations: boolean;
  hasSizepassport: boolean;
  hasUsedSizepassport: boolean;
  isCmLite: boolean;
  cmLiteFabricAvailable: boolean;
  sizePassportFitBucket: string;
  deliveryDays: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * Product Clicked: When clicking on a product to go to PLP, or in a panel when clicking on 'select size' When a product is shown in the viewport
 * 
 * When to trigger this event:
 * 1. When clicking on a product on a PLP
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3/trigger/hFTLKlhB8
 * 2. When clicking on a product on a PDP in the 'You Might Also Like' carousel. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3/trigger/uc6_I1PJe
 * 3. When clicking on 'Select Size' in the 'Shop the Look' panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3/trigger/2eMjubKrf
 * 4. When clicking on a product on a Journal
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3/trigger/cWUk2zzqA
 * 5. When clicking on a product on the store locator page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3/trigger/Bpf-If4w-
 * 6. When clicking on a product on a store detail page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3/trigger/D-ioHoDIM
 * 7. When clicking on 'shop giftcard' button, on the Giftcard landing page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3/trigger/ecFszVd66
 * 8. When the customer taps an item image in the Customer Hub Wishlist tab (online) and the PDP opens (item_list_name = wishlist, list_id = customer_hub_wishlist, event_location = customer_hub_wishlist).
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3/trigger/H5hE5UDxxAX_ndoFjJyp0
 * 
 * @param properties the properties associated with this event
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.imageUrl: URL of shown image/hero of product
 * Can sometimes be different from viewport url
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
 * - havana
 * - milano
 * - roma
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false'
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * For CM Lite: sku should contain selected RTW code or 'cm_trousers' for CM fits or RTW fits out of stock
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * @param properties.sliderImageNumber: This property pinpoints the exact product image visible on the product placeholder at the time of interaction. Its main function is to offer valuable data on user engagement with the product image slider. By capturing which image was displayed during an interaction, we can analyze if, and how, users are utilizing this feature, ultimately informing design improvements and optimizing user experience.
 * @param properties.hasImageSliderInteraction: This property indicates whether the user has interacted with the product listing page (PLP) image slider for the product.
 * @param properties.includedAlterations: This property indicates whether the user selected the alterations available in the Size Passport to be included in the product. A true value confirms that the product is a custom size. A false value confirms that the product is a standard size.
 * Note (Aug 2026): currently scoped to trousers only — on product_added, true only ever appears with category = trousers, even though the property itself is populated across ~89% of add-to-bag events. Update this note if Size Passport alterations expand to other categories.
 * @param properties.hasSizepassport: Whether the customer has a size passport.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true only appears with category = trousers there. The custom_made app source also sets it true broadly but never populates category, so it can't be sliced by product type. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true is overwhelmingly category = trousers, with a thin tail elsewhere. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.isCmLite: This property describes if the product has custom made lite fits enabled. Default as false.
 * @param properties.cmLiteFabricAvailable: This property describes if for that product the Custom Made lite fabric is available.
 * @param properties.sizePassportFitBucket: Property that indicates the original fit bucket, where the Size Passport was created. We want to enable tracking of whether the Size Passport recommendation was used within the same fit bucket or across different fit buckets. This will allow us to compare it against the fit of the garment ultimately purchased. Values come from raw.measurements__fit.bucket, e.g. 'Fit Bucket Milano'.
 * @param properties.deliveryDays: This property represents delivery days in a delivery promise message, e.g 'Delivery 1-2 weeks' for CM Lite products
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3}
 */
export function productClicked(properties: ProductClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
  eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
  eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
  eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
  properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
  properties.fitId !== undefined && properties.fitId !== null ?
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
  eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
  eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
  eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
  eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
  eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  properties.fullLook !== undefined && properties.fullLook !== null ?
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "xmEpd00WyoeakoDq0l-G2", name: "slider_image_number", value: properties.sliderImageNumber});
  eventPropertiesArray.push({id: "YIzniusZYA5E7kGaG0Dey", name: "has_image_slider_interaction", value: properties.hasImageSliderInteraction});
  eventPropertiesArray.push({id: "GjML-ubj3ekTomHsZWczH", name: "included_alterations", value: properties.includedAlterations});
  eventPropertiesArray.push({id: "N05TvU18S", name: "has_sizepassport", value: properties.hasSizepassport});
  eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport});
  eventPropertiesArray.push({id: "Gjk39Ttu4rGWlVqmFNqHc", name: "is_cm_lite", value: properties.isCmLite});
  eventPropertiesArray.push({id: "AGoi3z0CZHAYb7XFn_W66", name: "cm_lite_fabric_available", value: properties.cmLiteFabricAvailable});
  eventPropertiesArray.push({id: "ezR_7-4smAYg-g5bsWCXd", name: "size_passport_fit_bucket", value: properties.sizePassportFitBucket});
  eventPropertiesArray.push({id: "in2NkIW7WHc6aGBxP1jd2", name: "delivery_days", value: properties.deliveryDays});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "kHvR74th3", "513a82a5ff1501b9e45fc735324aa9ce113d61fe93c4786fc65bc398194e04f7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("kHvR74th3", "Product Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Clicked': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Clicked", eventProperties, "kHvR74th3", "513a82a5ff1501b9e45fc735324aa9ce113d61fe93c4786fc65bc398194e04f7");
    }
    // destination Segment
    Segment.logEvent("Product Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductClickedSimilarProductsProperties {
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string | null | undefined;
  variant: string;
  price: number;
  quantity: number;
  position: number;
  imageUrl: string;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  plpGridImages: string;
  shopTheLookId: string;
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
  sliderImageNumber: number;
  hasImageSliderInteraction: boolean;
  includedAlterations: boolean;
  hasSizepassport: boolean;
  hasUsedSizepassport: boolean;
  isCmLite: boolean;
  cmLiteFabricAvailable: boolean;
  sizePassportFitBucket: string;
  deliveryDays: string;
  currency: CurrencyValueType | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  itemListName: ItemListNameValueType;
}
/**
 * Product Clicked: When clicking on a product to go to PLP, or in a panel when clicking on 'select size' When a product is shown in the viewport
 * , event variant
 * 
 * When to trigger this event:
 * 1. When the user clicks on a product in the "Similar Products" list
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3.ifkXa9S8M/trigger/RrxM61iG8tm
 * 2. When the user clicks on a product in the "Similar Products" list
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3.ifkXa9S8M/trigger/eCmOMXGWZye
 * 
 * @param properties the properties associated with this event
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.imageUrl: URL of shown image/hero of product
 * Can sometimes be different from viewport url
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
 * - havana
 * - milano
 * - roma
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false'
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * For CM Lite: sku should contain selected RTW code or 'cm_trousers' for CM fits or RTW fits out of stock
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * @param properties.sliderImageNumber: This property pinpoints the exact product image visible on the product placeholder at the time of interaction. Its main function is to offer valuable data on user engagement with the product image slider. By capturing which image was displayed during an interaction, we can analyze if, and how, users are utilizing this feature, ultimately informing design improvements and optimizing user experience.
 * @param properties.hasImageSliderInteraction: This property indicates whether the user has interacted with the product listing page (PLP) image slider for the product.
 * @param properties.includedAlterations: This property indicates whether the user selected the alterations available in the Size Passport to be included in the product. A true value confirms that the product is a custom size. A false value confirms that the product is a standard size.
 * Note (Aug 2026): currently scoped to trousers only — on product_added, true only ever appears with category = trousers, even though the property itself is populated across ~89% of add-to-bag events. Update this note if Size Passport alterations expand to other categories.
 * @param properties.hasSizepassport: Whether the customer has a size passport.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true only appears with category = trousers there. The custom_made app source also sets it true broadly but never populates category, so it can't be sliced by product type. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true is overwhelmingly category = trousers, with a thin tail elsewhere. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.isCmLite: This property describes if the product has custom made lite fits enabled. Default as false.
 * @param properties.cmLiteFabricAvailable: This property describes if for that product the Custom Made lite fabric is available.
 * @param properties.sizePassportFitBucket: Property that indicates the original fit bucket, where the Size Passport was created. We want to enable tracking of whether the Size Passport recommendation was used within the same fit bucket or across different fit buckets. This will allow us to compare it against the fit of the garment ultimately purchased. Values come from raw.measurements__fit.bucket, e.g. 'Fit Bucket Milano'.
 * @param properties.deliveryDays: This property represents delivery days in a delivery promise message, e.g 'Delivery 1-2 weeks' for CM Lite products
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3.ifkXa9S8M}
 */
export function productClickedSimilarProducts(properties: ProductClickedSimilarProductsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
  eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
  eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
  eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
  properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
  properties.fitId !== undefined && properties.fitId !== null ?
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
  eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
  eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
  eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
  eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
  eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  properties.fullLook !== undefined && properties.fullLook !== null ?
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "xmEpd00WyoeakoDq0l-G2", name: "slider_image_number", value: properties.sliderImageNumber});
  eventPropertiesArray.push({id: "YIzniusZYA5E7kGaG0Dey", name: "has_image_slider_interaction", value: properties.hasImageSliderInteraction});
  eventPropertiesArray.push({id: "GjML-ubj3ekTomHsZWczH", name: "included_alterations", value: properties.includedAlterations});
  eventPropertiesArray.push({id: "N05TvU18S", name: "has_sizepassport", value: properties.hasSizepassport});
  eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport});
  eventPropertiesArray.push({id: "Gjk39Ttu4rGWlVqmFNqHc", name: "is_cm_lite", value: properties.isCmLite});
  eventPropertiesArray.push({id: "AGoi3z0CZHAYb7XFn_W66", name: "cm_lite_fabric_available", value: properties.cmLiteFabricAvailable});
  eventPropertiesArray.push({id: "ezR_7-4smAYg-g5bsWCXd", name: "size_passport_fit_bucket", value: properties.sizePassportFitBucket});
  eventPropertiesArray.push({id: "in2NkIW7WHc6aGBxP1jd2", name: "delivery_days", value: properties.deliveryDays});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: "similar_products"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "kHvR74th3.ifkXa9S8M", "db2c1f70cd35395f25c5ee996b1fd45e330a461a5a2cc5b3ab4031b1ba72f4cd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("kHvR74th3.ifkXa9S8M", "Product Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Clicked': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Clicked", eventProperties, "kHvR74th3.ifkXa9S8M", "db2c1f70cd35395f25c5ee996b1fd45e330a461a5a2cc5b3ab4031b1ba72f4cd");
    }
    // destination Segment
    Segment.logEvent("Product Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductClickedCustomMinusmadeMinusliteProperties {
  listId: string;
  itemListName: ItemListNameValueType;
  productId: string;
  price: number;
  sku: string;
  fullLook: string | null | undefined;
  hasSizepassport: boolean;
  hasUsedSizepassport: boolean;
  isCmLite: boolean;
  cmLiteFabricAvailable: boolean;
  currency: CurrencyValueType | null | undefined;
  flowId: string | null | undefined;
  cmLiteEntryProductId: string | null | undefined;
  deliveryDays: string | null | undefined;
}
/**
 * Product Clicked: When clicking on a product to go to PLP, or in a panel when clicking on 'select size' When a product is shown in the viewport
 * variant description: This product list viewed is triggered when the user goes to Size picker in the custom made lite panel in the PDP. 
 * The item_list_name should be "custom made lite"
 * The list_id should be the Product Id from the PDP
 * The product_id should contain RTW code matching currently selected fit or "cm_trousers" for CM only fits.
 * sku should contain selected RTW code or  "cm_trousers"for CM fits or RTW fits out of stock
 * delivery_days should contain the delivery promise shown to the user for selected fit
 * 
 * When to trigger this event:
 * 1. When the fit and variant are selected and the user goes to Select your size panel for a custom made lite product
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3.UR_BHg1YNy5-_X9024LqR/trigger/3V6bMiDm0kkiuBRF2AEof
 * 
 * @param properties the properties associated with this event
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.price: Price of single product
 * @param properties.sku: SKU of product, same as product_id
 * For CM Lite: sku should contain selected RTW code or 'cm_trousers' for CM fits or RTW fits out of stock
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.hasSizepassport: Whether the customer has a size passport.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true only appears with category = trousers there. The custom_made app source also sets it true broadly but never populates category, so it can't be sliced by product type. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true is overwhelmingly category = trousers, with a thin tail elsewhere. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.isCmLite: This property describes if the product has custom made lite fits enabled. Default as false.
 * @param properties.cmLiteFabricAvailable: This property describes if for that product the Custom Made lite fabric is available.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.cmLiteEntryProductId: Product code of the PDP where the customer opened the CM Lite panel (product A). The added or selected product (product B) is in product_id.
 * @param properties.deliveryDays: This property represents delivery days in a delivery promise message, e.g 'Delivery 1-2 weeks' for CM Lite products
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/kHvR74th3.UR_BHg1YNy5-_X9024LqR}
 */
export function productClickedCustomMadeLite(properties: ProductClickedCustomMinusmadeMinusliteProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  properties.fullLook !== undefined && properties.fullLook !== null ?
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
  eventPropertiesArray.push({id: "N05TvU18S", name: "has_sizepassport", value: properties.hasSizepassport});
  eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport});
  eventPropertiesArray.push({id: "Gjk39Ttu4rGWlVqmFNqHc", name: "is_cm_lite", value: properties.isCmLite});
  eventPropertiesArray.push({id: "AGoi3z0CZHAYb7XFn_W66", name: "cm_lite_fabric_available", value: properties.cmLiteFabricAvailable});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  properties.flowId !== undefined && properties.flowId !== null ?
    eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId}) :
    eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: null});
  properties.cmLiteEntryProductId !== undefined && properties.cmLiteEntryProductId !== null ?
    eventPropertiesArray.push({id: "A86OnAXSov5v_E1q05wXn", name: "cm_lite_entry_product_id", value: properties.cmLiteEntryProductId}) :
    eventPropertiesArray.push({id: "A86OnAXSov5v_E1q05wXn", name: "cm_lite_entry_product_id", value: null});
  properties.deliveryDays !== undefined && properties.deliveryDays !== null ?
    eventPropertiesArray.push({id: "in2NkIW7WHc6aGBxP1jd2", name: "delivery_days", value: properties.deliveryDays}) :
    eventPropertiesArray.push({id: "in2NkIW7WHc6aGBxP1jd2", name: "delivery_days", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "kHvR74th3.UR_BHg1YNy5-_X9024LqR", "c2d46860088869e9315ca1c4f87a46e38d0f42984904edaa3ec0b055f7af846e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("kHvR74th3.UR_BHg1YNy5-_X9024LqR", "Product Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Clicked': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Clicked", eventProperties, "kHvR74th3.UR_BHg1YNy5-_X9024LqR", "c2d46860088869e9315ca1c4f87a46e38d0f42984904edaa3ec0b055f7af846e");
    }
    // destination Segment
    Segment.logEvent("Product Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductAddedToWishlistProperties {
  listId: string;
  itemListName: ItemListNameValueType;
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string | null | undefined;
  variant: string;
  price: number;
  quantity: number;
  position: number;
  imageUrl: string;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  plpGridImages: string;
  shopTheLookId: string;
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  includedAlterations: boolean;
  hasSizepassport: boolean;
  hasUsedSizepassport: boolean;
  sliderImageNumber: number;
  isCmLite: boolean;
  cmLiteFabricAvailable: boolean;
  sizePassportFitBucket: string;
  currency: CurrencyValueType | null | undefined;
  variantId: string;
  outOfStock: boolean;
  loginSource: LoginSourceValueType | null | undefined;
}
/**
 * Product Added to Wishlist: When landing an a PDP and clicking the add to wishlist icon
 * For full looks, fire an add_to_wishlist event for every specific product.
 * 
 * When to trigger this event:
 * 1. When selecting the 'Add to Wishlist' icon.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MoZcZa9Kt/trigger/21cyJ2qeD
 * 2. When the customer taps the bookmark again on a greyed-out item in the Customer Hub Wishlist tab (event_location = customer_hub_wishlist), undoing a removal.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MoZcZa9Kt/trigger/DyjezAahFeAjgBpoEQElC
 * 
 * @param properties the properties associated with this event
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.imageUrl: URL of shown image/hero of product
 * Can sometimes be different from viewport url
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
 * - havana
 * - milano
 * - roma
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false'
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * For CM Lite: sku should contain selected RTW code or 'cm_trousers' for CM fits or RTW fits out of stock
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.includedAlterations: This property indicates whether the user selected the alterations available in the Size Passport to be included in the product. A true value confirms that the product is a custom size. A false value confirms that the product is a standard size.
 * Note (Aug 2026): currently scoped to trousers only — on product_added, true only ever appears with category = trousers, even though the property itself is populated across ~89% of add-to-bag events. Update this note if Size Passport alterations expand to other categories.
 * @param properties.hasSizepassport: Whether the customer has a size passport.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true only appears with category = trousers there. The custom_made app source also sets it true broadly but never populates category, so it can't be sliced by product type. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true is overwhelmingly category = trousers, with a thin tail elsewhere. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.sliderImageNumber: This property pinpoints the exact product image visible on the product placeholder at the time of interaction. Its main function is to offer valuable data on user engagement with the product image slider. By capturing which image was displayed during an interaction, we can analyze if, and how, users are utilizing this feature, ultimately informing design improvements and optimizing user experience.
 * @param properties.isCmLite: This property describes if the product has custom made lite fits enabled. Default as false.
 * @param properties.cmLiteFabricAvailable: This property describes if for that product the Custom Made lite fabric is available.
 * @param properties.sizePassportFitBucket: Property that indicates the original fit bucket, where the Size Passport was created. We want to enable tracking of whether the Size Passport recommendation was used within the same fit bucket or across different fit buckets. This will allow us to compare it against the fit of the garment ultimately purchased. Values come from raw.measurements__fit.bucket, e.g. 'Fit Bucket Milano'.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.variantId: Variant ID is SKU + code for size. This is often available starting from 'Product Added' event.
 * Example:
 * https://suitsupply.com/en-nl/men/trousers/off-white-firenze-trousers/B3022.html
 * SKU: 'SW1811'
 * variant_id: 'SW181104'
 * @param properties.outOfStock: Whether the selected product or size is out of stock. true = out of stock (sold out), false = in stock.
 * @param properties.loginSource: Where the login that led the customer back to the action was started: login_nudge (the logged-out nudge in the size picker), size_passport_tab (the login button on the size passport tab), or wishlist_save (the 'Save for later' sign-in shown when a signed-out customer saves to the wishlist; sent on the save that completes after sign-in).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MoZcZa9Kt}
 */
export function productAddedToWishlist(properties: ProductAddedToWishlistProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
  eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
  eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
  eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
  properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
  properties.fitId !== undefined && properties.fitId !== null ?
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
  eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
  eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
  eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
  eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
  eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  properties.fullLook !== undefined && properties.fullLook !== null ?
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "GjML-ubj3ekTomHsZWczH", name: "included_alterations", value: properties.includedAlterations});
  eventPropertiesArray.push({id: "N05TvU18S", name: "has_sizepassport", value: properties.hasSizepassport});
  eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport});
  eventPropertiesArray.push({id: "xmEpd00WyoeakoDq0l-G2", name: "slider_image_number", value: properties.sliderImageNumber});
  eventPropertiesArray.push({id: "Gjk39Ttu4rGWlVqmFNqHc", name: "is_cm_lite", value: properties.isCmLite});
  eventPropertiesArray.push({id: "AGoi3z0CZHAYb7XFn_W66", name: "cm_lite_fabric_available", value: properties.cmLiteFabricAvailable});
  eventPropertiesArray.push({id: "ezR_7-4smAYg-g5bsWCXd", name: "size_passport_fit_bucket", value: properties.sizePassportFitBucket});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "F-139zDCY", name: "variant_id", value: properties.variantId});
  eventPropertiesArray.push({id: "gHO_HPRSg", name: "out_of_stock", value: properties.outOfStock});
  properties.loginSource !== undefined && properties.loginSource !== null ?
    eventPropertiesArray.push({id: "SMG9E19y9p_XViD-PCVpc", name: "login_source", value: properties.loginSource}) :
    eventPropertiesArray.push({id: "SMG9E19y9p_XViD-PCVpc", name: "login_source", value: null});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MoZcZa9Kt", "efa5bc0642fe0200d10e0a45820ae0dd011e2e0ab39f2eb0cef72629b7445709", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Added to Wishlist", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MoZcZa9Kt", "Product Added to Wishlist", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Added to Wishlist': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added to Wishlist", eventProperties, "MoZcZa9Kt", "efa5bc0642fe0200d10e0a45820ae0dd011e2e0ab39f2eb0cef72629b7445709");
    }
    // destination Segment
    Segment.logEvent("Product Added to Wishlist", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductAddedToWishlistOutOfStockProperties {
  listId: string;
  itemListName: ItemListNameValueType;
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string | null | undefined;
  variant: string;
  price: number;
  quantity: number;
  position: number;
  imageUrl: string;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  plpGridImages: string;
  shopTheLookId: string;
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
  eventLabel: string | null | undefined;
  includedAlterations: boolean;
  hasSizepassport: boolean;
  hasUsedSizepassport: boolean;
  sliderImageNumber: number;
  isCmLite: boolean;
  cmLiteFabricAvailable: boolean;
  sizePassportFitBucket: string;
  currency: CurrencyValueType | null | undefined;
  variantId: string;
  loginSource: LoginSourceValueType | null | undefined;
  eventLocation: string;
  outOfStock: boolean;
}
/**
 * Product Added to Wishlist: When landing an a PDP and clicking the add to wishlist icon
 * For full looks, fire an add_to_wishlist event for every specific product., variant description: This variant is designed to monitor products added to the wishlist that are currently out of stock. Consequently, we can utilize this event to segment users who have out-of-stock items in their wishlist and will be affected by back to stock notifications.
 * 
 * When to trigger this event:
 * 1. When the user clicks in "Add to Saved" on the out of stock item message
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MoZcZa9Kt.ArNrE0Iib/trigger/woVdajZYlqN
 * 
 * @param properties the properties associated with this event
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.imageUrl: URL of shown image/hero of product
 * Can sometimes be different from viewport url
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
 * - havana
 * - milano
 * - roma
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false'
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * For CM Lite: sku should contain selected RTW code or 'cm_trousers' for CM fits or RTW fits out of stock
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.includedAlterations: This property indicates whether the user selected the alterations available in the Size Passport to be included in the product. A true value confirms that the product is a custom size. A false value confirms that the product is a standard size.
 * Note (Aug 2026): currently scoped to trousers only — on product_added, true only ever appears with category = trousers, even though the property itself is populated across ~89% of add-to-bag events. Update this note if Size Passport alterations expand to other categories.
 * @param properties.hasSizepassport: Whether the customer has a size passport.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true only appears with category = trousers there. The custom_made app source also sets it true broadly but never populates category, so it can't be sliced by product type. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true is overwhelmingly category = trousers, with a thin tail elsewhere. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.sliderImageNumber: This property pinpoints the exact product image visible on the product placeholder at the time of interaction. Its main function is to offer valuable data on user engagement with the product image slider. By capturing which image was displayed during an interaction, we can analyze if, and how, users are utilizing this feature, ultimately informing design improvements and optimizing user experience.
 * @param properties.isCmLite: This property describes if the product has custom made lite fits enabled. Default as false.
 * @param properties.cmLiteFabricAvailable: This property describes if for that product the Custom Made lite fabric is available.
 * @param properties.sizePassportFitBucket: Property that indicates the original fit bucket, where the Size Passport was created. We want to enable tracking of whether the Size Passport recommendation was used within the same fit bucket or across different fit buckets. This will allow us to compare it against the fit of the garment ultimately purchased. Values come from raw.measurements__fit.bucket, e.g. 'Fit Bucket Milano'.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.variantId: Variant ID is SKU + code for size. This is often available starting from 'Product Added' event.
 * Example:
 * https://suitsupply.com/en-nl/men/trousers/off-white-firenze-trousers/B3022.html
 * SKU: 'SW1811'
 * variant_id: 'SW181104'
 * @param properties.loginSource: Where the login that led the customer back to the action was started: login_nudge (the logged-out nudge in the size picker), size_passport_tab (the login button on the size passport tab), or wishlist_save (the 'Save for later' sign-in shown when a signed-out customer saves to the wishlist; sent on the save that completes after sign-in).
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.outOfStock: Whether the selected product or size is out of stock. true = out of stock (sold out), false = in stock.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MoZcZa9Kt.ArNrE0Iib}
 */
export function productAddedToWishlistOutOfStock(properties: ProductAddedToWishlistOutOfStockProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
  eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
  eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
  eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
  properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
  properties.fitId !== undefined && properties.fitId !== null ?
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
  eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
  eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
  eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
  eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
  eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  properties.fullLook !== undefined && properties.fullLook !== null ?
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  eventPropertiesArray.push({id: "GjML-ubj3ekTomHsZWczH", name: "included_alterations", value: properties.includedAlterations});
  eventPropertiesArray.push({id: "N05TvU18S", name: "has_sizepassport", value: properties.hasSizepassport});
  eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport});
  eventPropertiesArray.push({id: "xmEpd00WyoeakoDq0l-G2", name: "slider_image_number", value: properties.sliderImageNumber});
  eventPropertiesArray.push({id: "Gjk39Ttu4rGWlVqmFNqHc", name: "is_cm_lite", value: properties.isCmLite});
  eventPropertiesArray.push({id: "AGoi3z0CZHAYb7XFn_W66", name: "cm_lite_fabric_available", value: properties.cmLiteFabricAvailable});
  eventPropertiesArray.push({id: "ezR_7-4smAYg-g5bsWCXd", name: "size_passport_fit_bucket", value: properties.sizePassportFitBucket});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "F-139zDCY", name: "variant_id", value: properties.variantId});
  properties.loginSource !== undefined && properties.loginSource !== null ?
    eventPropertiesArray.push({id: "SMG9E19y9p_XViD-PCVpc", name: "login_source", value: properties.loginSource}) :
    eventPropertiesArray.push({id: "SMG9E19y9p_XViD-PCVpc", name: "login_source", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "gHO_HPRSg", name: "out_of_stock", value: properties.outOfStock});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "ecommerce_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MoZcZa9Kt.ArNrE0Iib", "bcce7f75a31b97975f69634a1792da504b37cfe845e797b4e0d29f3340ab5028", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Added to Wishlist", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MoZcZa9Kt.ArNrE0Iib", "Product Added to Wishlist", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Added to Wishlist': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added to Wishlist", eventProperties, "MoZcZa9Kt.ArNrE0Iib", "bcce7f75a31b97975f69634a1792da504b37cfe845e797b4e0d29f3340ab5028");
    }
    // destination Segment
    Segment.logEvent("Product Added to Wishlist", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductRemovedFromWishlistProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  listId: string;
  itemListName: ItemListNameValueType;
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string | null | undefined;
  brand: BrandValueType;
  variant: string;
  price: number;
  quantity: number;
  position: number;
  imageUrl: string;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  plpGridImages: string;
  shopTheLookId: string;
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
  includedAlterations: boolean;
  hasSizepassport: boolean;
  hasUsedSizepassport: boolean;
  sliderImageNumber: number;
  isCmLite: boolean;
  cmLiteFabricAvailable: boolean;
  sizePassportFitBucket: string | null | undefined;
  variantId: string;
}
/**
 * Product Removed from Wishlist: When a product is removed from the wishlist by the customer.
 * For full looks, fire a remove_from_wishlist event for every specific product.
 * Do not fire when: the item is removed automatically by the system, for example on the page refresh after the item was added to the bag. Only customer taps on a filled bookmark count.
 * 
 * When to trigger this event:
 * 1. When deselecting the 'wishlist' icon.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/W4YUp-LsF/trigger/CZSsjO8fx
 * 2. When the customer taps the bookmark on an item in the Customer Hub Wishlist tab and the item greys out (event_location = customer_hub_wishlist). Fires on the tap, not when the item leaves the list.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/W4YUp-LsF/trigger/n9YKKgUPRSaZbBTnJMUQI
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.brand: Static value 'suitsupply'
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.imageUrl: URL of shown image/hero of product
 * Can sometimes be different from viewport url
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
 * - havana
 * - milano
 * - roma
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false'
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * For CM Lite: sku should contain selected RTW code or 'cm_trousers' for CM fits or RTW fits out of stock
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * @param properties.includedAlterations: This property indicates whether the user selected the alterations available in the Size Passport to be included in the product. A true value confirms that the product is a custom size. A false value confirms that the product is a standard size.
 * Note (Aug 2026): currently scoped to trousers only — on product_added, true only ever appears with category = trousers, even though the property itself is populated across ~89% of add-to-bag events. Update this note if Size Passport alterations expand to other categories.
 * @param properties.hasSizepassport: Whether the customer has a size passport.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true only appears with category = trousers there. The custom_made app source also sets it true broadly but never populates category, so it can't be sliced by product type. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true is overwhelmingly category = trousers, with a thin tail elsewhere. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.sliderImageNumber: This property pinpoints the exact product image visible on the product placeholder at the time of interaction. Its main function is to offer valuable data on user engagement with the product image slider. By capturing which image was displayed during an interaction, we can analyze if, and how, users are utilizing this feature, ultimately informing design improvements and optimizing user experience.
 * @param properties.isCmLite: This property describes if the product has custom made lite fits enabled. Default as false.
 * @param properties.cmLiteFabricAvailable: This property describes if for that product the Custom Made lite fabric is available.
 * @param properties.sizePassportFitBucket: Property that indicates the original fit bucket, where the Size Passport was created. We want to enable tracking of whether the Size Passport recommendation was used within the same fit bucket or across different fit buckets. This will allow us to compare it against the fit of the garment ultimately purchased. Values come from raw.measurements__fit.bucket, e.g. 'Fit Bucket Milano'.
 * @param properties.variantId: Variant ID is SKU + code for size. This is often available starting from 'Product Added' event.
 * Example:
 * https://suitsupply.com/en-nl/men/trousers/off-white-firenze-trousers/B3022.html
 * SKU: 'SW1811'
 * variant_id: 'SW181104'
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/W4YUp-LsF}
 */
export function productRemovedFromWishlist(properties: ProductRemovedFromWishlistProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
  eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
  eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
  eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: properties.brand});
  eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
  properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
  properties.fitId !== undefined && properties.fitId !== null ?
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
  eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
  eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
  eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
  eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
  eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  properties.fullLook !== undefined && properties.fullLook !== null ?
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "GjML-ubj3ekTomHsZWczH", name: "included_alterations", value: properties.includedAlterations});
  eventPropertiesArray.push({id: "N05TvU18S", name: "has_sizepassport", value: properties.hasSizepassport});
  eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport});
  eventPropertiesArray.push({id: "xmEpd00WyoeakoDq0l-G2", name: "slider_image_number", value: properties.sliderImageNumber});
  eventPropertiesArray.push({id: "Gjk39Ttu4rGWlVqmFNqHc", name: "is_cm_lite", value: properties.isCmLite});
  eventPropertiesArray.push({id: "AGoi3z0CZHAYb7XFn_W66", name: "cm_lite_fabric_available", value: properties.cmLiteFabricAvailable});
  properties.sizePassportFitBucket !== undefined && properties.sizePassportFitBucket !== null ?
    eventPropertiesArray.push({id: "ezR_7-4smAYg-g5bsWCXd", name: "size_passport_fit_bucket", value: properties.sizePassportFitBucket}) :
    eventPropertiesArray.push({id: "ezR_7-4smAYg-g5bsWCXd", name: "size_passport_fit_bucket", value: null});
  eventPropertiesArray.push({id: "F-139zDCY", name: "variant_id", value: properties.variantId});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "W4YUp-LsF", "d5572c2aaa8ee32e0271109525b258b7803ab61c986e65229a494c0b1a53a3f5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Removed from Wishlist", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("W4YUp-LsF", "Product Removed from Wishlist", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Removed from Wishlist': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Removed from Wishlist", eventProperties, "W4YUp-LsF", "d5572c2aaa8ee32e0271109525b258b7803ab61c986e65229a494c0b1a53a3f5");
    }
    // destination Segment
    Segment.logEvent("Product Removed from Wishlist", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FaqOpenProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string | null | undefined;
  userType: UserTypeValueType[];
}
/**
 * faq_open: When clicking in the navigation menu of support links
 * event_label: faq question in native language
 * 
 * When to trigger this event:
 * 1. when clicking on the faq dropdown links 

event_location: support-page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/nqxV9XZOW/trigger/VJ9-V4AXb
 * 2. When a user clicks on an faq accordion in the order details in the customer hub
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/nqxV9XZOW/trigger/rsuWW8iDkMChnH3F6kQGq
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/nqxV9XZOW}
 */
export function faqOpen(properties: FaqOpenProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  properties.eventLocation !== undefined && properties.eventLocation !== null ?
    eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation}) :
    eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: null});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "nqxV9XZOW", "6c52e5e90db20dfbca68e7d90d80de9cf814e5077c7826e465e4c3823ff71351", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("faq_open", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("nqxV9XZOW", "faq_open", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("faq_open", eventProperties, "nqxV9XZOW", "6c52e5e90db20dfbca68e7d90d80de9cf814e5077c7826e465e4c3823ff71351");
    }
    // destination Segment
    Segment.logEvent("faq_open", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomerInformationEditedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
}
/**
 * customer_information_edited: This event represents when the customer infromation has been modified from the customer hub by a Style Advisor.
 * 
 * When to trigger this event:
 * 1. the "save" button is clicked on the edit customer information screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/be2cabe1-63d9-47f8-9783-3cc406fb639b/trigger/d89jVIhK51-lSXl3txPTr
 * 2. When a user clicks "save info" and successfully updates the customer information in the new customer hub
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/be2cabe1-63d9-47f8-9783-3cc406fb639b/trigger/NYuh7L1xlJnCEprvwwfiy
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/be2cabe1-63d9-47f8-9783-3cc406fb639b}
 */
export function customerInformationEdited(properties: CustomerInformationEditedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "be2cabe1-63d9-47f8-9783-3cc406fb639b", "87ec8dd04370e62bc72854746d312bea238980c9873d98c040e8fb06faf44d61", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("customer_information_edited", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("be2cabe1-63d9-47f8-9783-3cc406fb639b", "customer_information_edited", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("customer_information_edited", eventProperties, "be2cabe1-63d9-47f8-9783-3cc406fb639b", "87ec8dd04370e62bc72854746d312bea238980c9873d98c040e8fb06faf44d61");
    }
    // destination Segment
    Segment.logEvent("customer_information_edited", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomerHubOpenedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
  storeId: string | null | undefined;
}
/**
 * customer_hub_opened: This event represents when the customer hub page is opened.
 * 
 * When to trigger this event:
 * 1. the customer tile is clicked with a customer selected on predict spring
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/cc8cee64-999e-4e36-8c3d-3d10ae465998/trigger/uV9LxePJkDMSRGl6FqnBy
 * 2. clicking on the "cutomer" option in the "Cart Options" menu
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/cc8cee64-999e-4e36-8c3d-3d10ae465998/trigger/yxgor0FU2qi4A4kYBuJUR
 * 3. there is no customer selected on predict spring, selecting a customer from the active customer list.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/cc8cee64-999e-4e36-8c3d-3d10ae465998/trigger/y8VGkcAZTb8zsN-ButAe_
 * 4. Clicking on the "account" icon on the channels where customer hub is enabled. (not my account)
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/cc8cee64-999e-4e36-8c3d-3d10ae465998/trigger/NhNX_i_ulDbQhA3QAB_y0
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/cc8cee64-999e-4e36-8c3d-3d10ae465998}
 */
export function customerHubOpened(properties: CustomerHubOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  properties.storeId !== undefined && properties.storeId !== null ?
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId}) :
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "cc8cee64-999e-4e36-8c3d-3d10ae465998", "d8b6e8fbe269af1377ec7ca9fc26afa3c0886a8c0dc107916875bb8e663fcc12", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("customer_hub_opened", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("cc8cee64-999e-4e36-8c3d-3d10ae465998", "customer_hub_opened", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("customer_hub_opened", eventProperties, "cc8cee64-999e-4e36-8c3d-3d10ae465998", "d8b6e8fbe269af1377ec7ca9fc26afa3c0886a8c0dc107916875bb8e663fcc12");
    }
    // destination Segment
    Segment.logEvent("customer_hub_opened", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomerSelectedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
  storeId: string | null | undefined;
}
/**
 * customer_selected: This event represents when the users click on "select user" to select the user on predict spring
 * 
 * When to trigger this event:
 * 1. the user clicks on "select customer"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MmyQXjjKAjQinUfmWeYae/trigger/yxgK3OlTAahnURmXXHMW2
 * 2. When a style advisor clicks on "select customer
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MmyQXjjKAjQinUfmWeYae/trigger/9FXVLKMc5ZYjVz1flM1bW
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MmyQXjjKAjQinUfmWeYae}
 */
export function customerSelected(properties: CustomerSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  properties.storeId !== undefined && properties.storeId !== null ?
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId}) :
    eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MmyQXjjKAjQinUfmWeYae", "9318a5488366c8d2fa6588136a06904fbf65af5c1fa946206be4a9b96abb41f5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("customer_selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MmyQXjjKAjQinUfmWeYae", "customer_selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("customer_selected", eventProperties, "MmyQXjjKAjQinUfmWeYae", "9318a5488366c8d2fa6588136a06904fbf65af5c1fa946206be4a9b96abb41f5");
    }
    // destination Segment
    Segment.logEvent("customer_selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ReturnOrderClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  orderId: string;
  userType: UserTypeValueType[];
  currency: CurrencyValueType | null | undefined;
  locationCode: string | null | undefined;
}
/**
 * return_order_clicked: This event represents when the user clicks in the "Return" button in the Orders and Returns section
 * 
 * When to trigger this event:
 * 1. Then the user clicks in the "Return" button in the orders and returns
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Et2HOk3VLBzOtAOPg9Ojz/trigger/ZLnatqtGTTGVuLb1RXO4n
 * 2. When a customer clicks on "return" on the order details in the customer hub
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Et2HOk3VLBzOtAOPg9Ojz/trigger/V3o7UWw37t_PKKDm1u1xJ
 * 3. the user clicks "return or exchange" or "return" on an active card
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Et2HOk3VLBzOtAOPg9Ojz/trigger/mL2DbQaKdD31AClzVfrv-
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.orderId: transaction id (native property of ecommerce object within Segment)
 * @param properties.userType: Describes whee
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Et2HOk3VLBzOtAOPg9Ojz}
 */
export function returnOrderClicked(properties: ReturnOrderClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "9aTQ52H3v", name: "order_id", value: properties.orderId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Et2HOk3VLBzOtAOPg9Ojz", "3eca36ae5868c44ffb9476089dadee9a33a6c93fb8d698ba53aa0cecb945c495", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("return_order_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Et2HOk3VLBzOtAOPg9Ojz", "return_order_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("return_order_clicked", eventProperties, "Et2HOk3VLBzOtAOPg9Ojz", "3eca36ae5868c44ffb9476089dadee9a33a6c93fb8d698ba53aa0cecb945c495");
    }
    // destination Segment
    Segment.logEvent("return_order_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomerAddressEditedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  addressType: AddressTypeValueType;
  addressFields: AddressFieldsValueType[];
  userType: UserTypeValueType[];
}
/**
 * customer_address_edited: This event describes when a customer's address has been modified
 * 
 * When to trigger this event:
 * 1. When a user clicks "save customer" and successfully modifies the address details
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/9c21e419-91d6-4e74-a600-5228c0a22d58/trigger/Tdb0FNaUCr975IJO_Reid
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.addressType: Describes whether an address is shipping or biling
 * @param properties.addressFields: Lists the modified address fields
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/9c21e419-91d6-4e74-a600-5228c0a22d58}
 */
export function customerAddressEdited(properties: CustomerAddressEditedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "NTf3wiPrNhZYoGPbu5xg0", name: "address_type", value: properties.addressType});
  eventPropertiesArray.push({id: "Mh0cvTEd1tBnL3b_buJs2", name: "address_fields", value: properties.addressFields});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "9c21e419-91d6-4e74-a600-5228c0a22d58", "398b71bf210749d94a5db949cfa97a8e9fc8f25567101d3b387c01591c79928b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("customer_address_edited", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("9c21e419-91d6-4e74-a600-5228c0a22d58", "customer_address_edited", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("customer_address_edited", eventProperties, "9c21e419-91d6-4e74-a600-5228c0a22d58", "398b71bf210749d94a5db949cfa97a8e9fc8f25567101d3b387c01591c79928b");
    }
    // destination Segment
    Segment.logEvent("customer_address_edited", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TabClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  tab: TabValueType[];
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
}
/**
 * tab_clicked: This event describes when a tab of the customer hub has been clicked
 * 
 * When to trigger this event:
 * 1. When a user clicks the tab bar on the customer hub
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/bgEzIsGIogX13Uqyvz19l/trigger/TVETQeNgo7ph5LW4rriyW
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.tab: Describes the selected name of the tab in the customer hub
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/bgEzIsGIogX13Uqyvz19l}
 */
export function tabClicked(properties: TabClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "5jZOdXVfj_sphp1VsS1HD", name: "tab", value: properties.tab});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "bgEzIsGIogX13Uqyvz19l", "df9270fee890b1a0fc20fc674a06639603ea80cca7d61b6b20ecf1e90bf8e9af", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("tab_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("bgEzIsGIogX13Uqyvz19l", "tab_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("tab_clicked", eventProperties, "bgEzIsGIogX13Uqyvz19l", "df9270fee890b1a0fc20fc674a06639603ea80cca7d61b6b20ecf1e90bf8e9af");
    }
    // destination Segment
    Segment.logEvent("tab_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ReturnedToAclProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
}
/**
 * returned_to_acl: This event describes when a style advisor click on "customers in store" to see the ACL
 * 
 * When to trigger this event:
 * 1. When a style advisor clicks on "customers in store" to return to the ACL
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/VTYSeTM1Mj9MZjYMNYAhT/trigger/ajJ55Ib3kSFTHmNEFcm-X
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/VTYSeTM1Mj9MZjYMNYAhT}
 */
export function returnedToAcl(properties: ReturnedToAclProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "VTYSeTM1Mj9MZjYMNYAhT", "c757709349bbd66f87d70427d0c35f31f0e160114d2aa4421ddda0099d72ce1e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("returned_to_acl", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("VTYSeTM1Mj9MZjYMNYAhT", "returned_to_acl", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("returned_to_acl", eventProperties, "VTYSeTM1Mj9MZjYMNYAhT", "c757709349bbd66f87d70427d0c35f31f0e160114d2aa4421ddda0099d72ce1e");
    }
    // destination Segment
    Segment.logEvent("returned_to_acl", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OrderClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
  orderId: string;
  locationCode: string | null | undefined;
}
/**
 * order_clicked: This event describes when customer's order on their order history has been clicked
 * 
 * When to trigger this event:
 * 1. When a user clicks on an order in the order history
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MVSN9ZtFs6RAxra-nQVpa/trigger/P5UOj0rV51xrEZxPk6gO6
 * 2. A user clicks on an order in the active card in the overview
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MVSN9ZtFs6RAxra-nQVpa/trigger/1KpVirg1b87uIqKoUxB_b
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * @param properties.orderId: transaction id (native property of ecommerce object within Segment)
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MVSN9ZtFs6RAxra-nQVpa}
 */
export function orderClicked(properties: OrderClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "9aTQ52H3v", name: "order_id", value: properties.orderId});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MVSN9ZtFs6RAxra-nQVpa", "24aaa372f1cf018e3689c07c5af8122425c04ce5167f6a0d1535d1d7c321d1f2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("order_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MVSN9ZtFs6RAxra-nQVpa", "order_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("order_clicked", eventProperties, "MVSN9ZtFs6RAxra-nQVpa", "24aaa372f1cf018e3689c07c5af8122425c04ce5167f6a0d1535d1d7c321d1f2");
    }
    // destination Segment
    Segment.logEvent("order_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CommunicationPreferencesSavedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  communicationPreferences: CommunicationPreferences;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
}
/**
 * communication_preferences_saved: This event described when the customer has saved communication preferences
 * 
 * When to trigger this event:
 * 1. when the user clicks "save preferences"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/N6CHO6B8mWvD4lvsmcmRb/trigger/jiArMR2idnn0in04cFW1C
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.communicationPreferences: The customer's communication preferences
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/N6CHO6B8mWvD4lvsmcmRb}
 */
export function communicationPreferencesSaved(properties: CommunicationPreferencesSavedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "sDlh7c0yvS7a0T6AcoGcQ", name: "communication_preferences", value: {
    "newsletter_status": properties.communicationPreferences.newsletterStatus,
  }});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertCommunicationPreferences(properties.communicationPreferences));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "N6CHO6B8mWvD4lvsmcmRb", "8932ca28acbf93def4834c2281ea163c5ad66a1d686be8833c3da312cea11919", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("communication_preferences_saved", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("N6CHO6B8mWvD4lvsmcmRb", "communication_preferences_saved", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'communication_preferences_saved': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("communication_preferences_saved", eventProperties, "N6CHO6B8mWvD4lvsmcmRb", "8932ca28acbf93def4834c2281ea163c5ad66a1d686be8833c3da312cea11919");
    }
    // destination Segment
    Segment.logEvent("communication_preferences_saved", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NewArrivalsButtonClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
}
/**
 * new_arrivals_button_clicked: This event represents when the user clicks in the "Shop new arrivals" button in the customer hub
 * 
 * When to trigger this event:
 * 1. When a customer clicks on "shop new arrivals" from the customer hub. This button is only visible when they have no  updates on their overview
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/2e01307a-ea0d-4c9c-ba09-14ff4c7a888f/trigger/WY9hvzhxf9lLMoVVbc1-Z
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/2e01307a-ea0d-4c9c-ba09-14ff4c7a888f}
 */
export function newArrivalsButtonClicked(properties: NewArrivalsButtonClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2e01307a-ea0d-4c9c-ba09-14ff4c7a888f", "f745e9a31311d755ae7de14e1fa9aaccb03473e27fe38e24e7a2aad1dd1cda36", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("new_arrivals_button_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2e01307a-ea0d-4c9c-ba09-14ff4c7a888f", "new_arrivals_button_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("new_arrivals_button_clicked", eventProperties, "2e01307a-ea0d-4c9c-ba09-14ff4c7a888f", "f745e9a31311d755ae7de14e1fa9aaccb03473e27fe38e24e7a2aad1dd1cda36");
    }
    // destination Segment
    Segment.logEvent("new_arrivals_button_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SettingsCustomerInfoClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
}
/**
 * settings_customer_info_clicked: This event represents when a user clicks on the customer info button under settings
 * 
 * When to trigger this event:
 * 1. When a user clicks on "customer info"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/B-nr5FPBPtL-njqNNQ4Lu/trigger/77gsvvpAAj_07cU8MLyTb
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/B-nr5FPBPtL-njqNNQ4Lu}
 */
export function settingsCustomerInfoClicked(properties: SettingsCustomerInfoClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "B-nr5FPBPtL-njqNNQ4Lu", "274e61dfd4adb5053313abdab8580754e0f4e01e3283fb7947837ee09faa163f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("settings_customer_info_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("B-nr5FPBPtL-njqNNQ4Lu", "settings_customer_info_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("settings_customer_info_clicked", eventProperties, "B-nr5FPBPtL-njqNNQ4Lu", "274e61dfd4adb5053313abdab8580754e0f4e01e3283fb7947837ee09faa163f");
    }
    // destination Segment
    Segment.logEvent("settings_customer_info_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SettingsAddressBookClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
}
/**
 * settings_address_book_clicked: This event represents when a user clicks on the address book button under settings
 * 
 * When to trigger this event:
 * 1. When a user clicks on "address book"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/q4Pag3w2ofW-fm1o5B6_J/trigger/AlVnZnB0E9dSqEYdb1C74
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/q4Pag3w2ofW-fm1o5B6_J}
 */
export function settingsAddressBookClicked(properties: SettingsAddressBookClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "q4Pag3w2ofW-fm1o5B6_J", "643bda492a1e50fa36e1ee1ab14dd8080e0e633cadf304363bc4c51ac29b1d62", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("settings_address_book_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("q4Pag3w2ofW-fm1o5B6_J", "settings_address_book_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("settings_address_book_clicked", eventProperties, "q4Pag3w2ofW-fm1o5B6_J", "643bda492a1e50fa36e1ee1ab14dd8080e0e633cadf304363bc4c51ac29b1d62");
    }
    // destination Segment
    Segment.logEvent("settings_address_book_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SettingsCommunicationClickledProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
}
/**
 * settings_communication_clickled: This event represents when a user clicks on the communication button under settings
 * 
 * When to trigger this event:
 * 1. When a user clicks on "communication"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/2B48i2SVxemc1RBRxObLH/trigger/ptXm6DIe6sqRfbQTwAh8n
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/2B48i2SVxemc1RBRxObLH}
 */
export function settingsCommunicationClickled(properties: SettingsCommunicationClickledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2B48i2SVxemc1RBRxObLH", "6f8dfd8877c0fdd452a71e7c64984a7f8a831b5d3d2e7a72dc388df2acbc962d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("settings_communication_clickled", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2B48i2SVxemc1RBRxObLH", "settings_communication_clickled", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("settings_communication_clickled", eventProperties, "2B48i2SVxemc1RBRxObLH", "6f8dfd8877c0fdd452a71e7c64984a7f8a831b5d3d2e7a72dc388df2acbc962d");
    }
    // destination Segment
    Segment.logEvent("settings_communication_clickled", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CancellationClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
}
/**
 * cancellation_clicked: This event describes when a user starts the cancellation process
 * 
 * When to trigger this event:
 * 1. When the user clicks on "cancel items" in the order details page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/8db5d22f-851b-4c1f-b3d8-01629eb74ad3/trigger/rNwS0GgdrFw-zm5WiIDS5
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/8db5d22f-851b-4c1f-b3d8-01629eb74ad3}
 */
export function cancellationClicked(properties: CancellationClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8db5d22f-851b-4c1f-b3d8-01629eb74ad3", "64d6e58bfb6691e0393a42ac0d98dfb6c756218802c2c6fcebd70ea6bbcce29c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cancellation_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8db5d22f-851b-4c1f-b3d8-01629eb74ad3", "cancellation_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cancellation_clicked", eventProperties, "8db5d22f-851b-4c1f-b3d8-01629eb74ad3", "64d6e58bfb6691e0393a42ac0d98dfb6c756218802c2c6fcebd70ea6bbcce29c");
    }
    // destination Segment
    Segment.logEvent("cancellation_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CancellationApprovedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
}
/**
 * cancellation_approved: This event describes when an authorised user approved the cancellation process
 * 
 * When to trigger this event:
 * 1. When the user clicks "continue" after providing valid credentials
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/P18E3n995E8S67yLS4J6X/trigger/KfS--jyoyrP_iTSlp6_4j
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/P18E3n995E8S67yLS4J6X}
 */
export function cancellationApproved(properties: CancellationApprovedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "P18E3n995E8S67yLS4J6X", "ef62832dadb90faa4d78341eff8dd741d275c991c13a72d2cd3f4f37570ac4e2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cancellation_approved", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("P18E3n995E8S67yLS4J6X", "cancellation_approved", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cancellation_approved", eventProperties, "P18E3n995E8S67yLS4J6X", "ef62832dadb90faa4d78341eff8dd741d275c991c13a72d2cd3f4f37570ac4e2");
    }
    // destination Segment
    Segment.logEvent("cancellation_approved", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CancellationConfirmedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
}
/**
 * cancellation_confirmed: This event describes when a user confirms the cancellation process, triggering a cancellation.
 * 
 * When to trigger this event:
 * 1. When the user clicks "Confirm cancellation" con the confirm cancellation screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/WYrk2arXC-2YcHwWk6G64/trigger/gFVzbvNYJ2PWJFLou8J4T
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/WYrk2arXC-2YcHwWk6G64}
 */
export function cancellationConfirmed(properties: CancellationConfirmedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "WYrk2arXC-2YcHwWk6G64", "616a85cfb1428c9bcc4a9fe883e3a64e902ac02250cdc025687cbba73aa80100", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cancellation_confirmed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("WYrk2arXC-2YcHwWk6G64", "cancellation_confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cancellation_confirmed", eventProperties, "WYrk2arXC-2YcHwWk6G64", "616a85cfb1428c9bcc4a9fe883e3a64e902ac02250cdc025687cbba73aa80100");
    }
    // destination Segment
    Segment.logEvent("cancellation_confirmed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TrackYourOrderClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  orderId: string;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
}
/**
 * track_your_order_clicked: Fired when a customer or style advisor taps "Track your order" on an Active Card in the Customer Hub.
 * 
 * When to trigger this event:
 * 1. a user clicks "track order" on an active card
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/GCsMdnbYkE0niN5zlEnOM/trigger/hNk65zrKeV38ScjVV0WVe
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.orderId: transaction id (native property of ecommerce object within Segment)
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/GCsMdnbYkE0niN5zlEnOM}
 */
export function trackYourOrderClicked(properties: TrackYourOrderClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "9aTQ52H3v", name: "order_id", value: properties.orderId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: "active_card"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "GCsMdnbYkE0niN5zlEnOM", "c162476658db1cb13523f6e1ac8572f95a8e1e51e48114fdc5725ddfa999459b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("track_your_order_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("GCsMdnbYkE0niN5zlEnOM", "track_your_order_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("track_your_order_clicked", eventProperties, "GCsMdnbYkE0niN5zlEnOM", "c162476658db1cb13523f6e1ac8572f95a8e1e51e48114fdc5725ddfa999459b");
    }
    // destination Segment
    Segment.logEvent("track_your_order_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookPickupAppointmentClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  orderId: string;
  userType: UserTypeValueType[];
  cardType: CardTypeValueType;
  locationCode: string | null | undefined;
}
/**
 * book_pickup_appointment_clicked: Fired when a customer or style advisor taps "Book appointment" on an Active Card (order or alteration) once it is ready for store pickup.
 * 
 * When to trigger this event:
 * 1. A user clicks on "book a pick-up appointment" in an active card
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/flniyA3CCJh0afQUfsan2/trigger/E2EW1D6pluNVONVgfNVFp
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.orderId: transaction id (native property of ecommerce object within Segment)
 * @param properties.userType: Describes whee
 * @param properties.cardType: Whether this Active Card is an order card or an alteration card.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/flniyA3CCJh0afQUfsan2}
 */
export function bookPickupAppointmentClicked(properties: BookPickupAppointmentClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "9aTQ52H3v", name: "order_id", value: properties.orderId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "jzkiA5tr__EMF5lu6ggsa", name: "card_type", value: properties.cardType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: "active_card"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "flniyA3CCJh0afQUfsan2", "640cdd8ae0e162a5f25b096ba160cf79d11bcea46eaabebd1cab1de5885acb47", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("book_pickup_appointment_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("flniyA3CCJh0afQUfsan2", "book_pickup_appointment_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("book_pickup_appointment_clicked", eventProperties, "flniyA3CCJh0afQUfsan2", "640cdd8ae0e162a5f25b096ba160cf79d11bcea46eaabebd1cab1de5885acb47");
    }
    // destination Segment
    Segment.logEvent("book_pickup_appointment_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ItemsInCartLoadedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
}
/**
 * items_in_cart_loaded: Describes when the items in cart component is loaded in the customer hub
 * 
 * When to trigger this event:
 * 1. The items in cart component is shown on screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/REgCyhobVD7EYd77kZ6ZA/trigger/RMt1BfBvKAnZD0vCS1L4b
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/REgCyhobVD7EYd77kZ6ZA}
 */
export function itemsInCartLoaded(properties: ItemsInCartLoadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "REgCyhobVD7EYd77kZ6ZA", "f190e278a091866ca2718aa891682723e8afcd3456fd70e0be7d4c78f2e32683", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("items_in_cart_loaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("REgCyhobVD7EYd77kZ6ZA", "items_in_cart_loaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("items_in_cart_loaded", eventProperties, "REgCyhobVD7EYd77kZ6ZA", "f190e278a091866ca2718aa891682723e8afcd3456fd70e0be7d4c78f2e32683");
    }
    // destination Segment
    Segment.logEvent("items_in_cart_loaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WardrobeItemClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
  productId: string;
  category: string;
  quantity: number;
  isCustomMade: boolean;
  locationCode: string | null | undefined;
}
/**
 * wardrobe_item_clicked: Describes when a User taps a product card in the Wardrobe tab, opening the detail panel
 * 
 * When to trigger this event:
 * 1. User taps a product card in the Wardrobe tab, opening the detail panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/1b13f173-a519-455f-b26d-a1685ccda6b5/trigger/_xNQCjypxO4F-JPL4D-Op
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.isCustomMade: Whether the wardrobe item is a Custom Made product (true) or a Ready to Wear product (false).
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/1b13f173-a519-455f-b26d-a1685ccda6b5}
 */
export function wardrobeItemClicked(properties: WardrobeItemClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "JhFP9jJk5a4m9Ftp3CMLb", name: "is_custom_made", value: properties.isCustomMade});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertQuantity(properties.quantity));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1b13f173-a519-455f-b26d-a1685ccda6b5", "93ce1cbb11193de6632882915144efa47e1c334460d5360c34802962c09a6c0c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("wardrobe_item_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1b13f173-a519-455f-b26d-a1685ccda6b5", "wardrobe_item_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'wardrobe_item_clicked': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("wardrobe_item_clicked", eventProperties, "1b13f173-a519-455f-b26d-a1685ccda6b5", "93ce1cbb11193de6632882915144efa47e1c334460d5360c34802962c09a6c0c");
    }
    // destination Segment
    Segment.logEvent("wardrobe_item_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NbaCardViewedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  cardId: string;
  employeeId: string;
  storeId: string;
  locationCode: string;
}
/**
 * nba_card_viewed: Fired when the Next Best Action card is shown on a customer's profile in Customer Hub's in-store view. Use for: the denominator of the NBA feedback response rate, per store and associate. Do not fire when: the NBA trait is empty or the NBA_cards_final flag is off (the card is not rendered).
 * 
 * When to trigger this event:
 * 1. When the Next Best Action card renders on the customer's Overview in Customer Hub's in-store view.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/rZxTlM2otYvyKVekP-DbR/trigger/mx_5YM3MVGP_9ZZshBDVg
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.cardId: Unique ID of the Next Best Action suggestion shown to the style advisor, taken from the NBA Segment trait in the Profile API response. Use for: joining feedback and views back to the generated NBA card (headline, reasons, model version). Example: 'nba_7f3c...'.
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/rZxTlM2otYvyKVekP-DbR}
 */
export function nbaCardViewed(properties: NbaCardViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "3V8G_u4aEZTaB7jnof2UJ", name: "card_id", value: properties.cardId});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "rZxTlM2otYvyKVekP-DbR", "342b51a5b280d0c358c4c51ae16bb0edc6fd899a74e5a8e5e6670728f4abb1c3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("nba_card_viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("rZxTlM2otYvyKVekP-DbR", "nba_card_viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("nba_card_viewed", eventProperties, "rZxTlM2otYvyKVekP-DbR", "342b51a5b280d0c358c4c51ae16bb0edc6fd899a74e5a8e5e6670728f4abb1c3");
    }
    // destination Segment
    Segment.logEvent("nba_card_viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NbaFeedbackSubmittedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  cardId: string;
  employeeId: string;
  storeId: string;
  rating: RatingValueType;
  feedback: string;
  locationCode: string;
}
/**
 * nba_feedback_submitted: Fired once when the style advisor finishes the Next Best Action feedback sheet after tapping thumbs up or thumbs down — on Send feedback, Skip, or closing the sheet. Use for: share of good ratings and qualitative notes to tune the NBA model; response rate together with nba_card_viewed. Do not fire when: the advisor never taps a thumb.
 * 
 * When to trigger this event:
 * 1. When the style advisor taps Send feedback, Skip or the close icon on the NBA feedback sheet opened by thumbs up/down on the Next Best Action card.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/_UHaNkJOxz5M_wphoRCyJ/trigger/NotjE0k4_kabkF2EQeBKY
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.cardId: Unique ID of the Next Best Action suggestion shown to the style advisor, taken from the NBA Segment trait in the Profile API response. Use for: joining feedback and views back to the generated NBA card (headline, reasons, model version). Example: 'nba_7f3c...'.
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.rating: The style advisor's rating of a Next Best Action suggestion: good (thumbs up) or bad (thumbs down). Use for: the share of useful suggestions per card, store and model version.
 * @param properties.feedback: Optional free-text note the style advisor typed in the Next Best Action feedback sheet. Sent as an empty string when they tap Skip or close the sheet without typing. Use for: qualitative review of what made a suggestion useful or wrong, to tune the NBA model. May contain customer details typed by the advisor — review PII/consent handling.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/_UHaNkJOxz5M_wphoRCyJ}
 */
export function nbaFeedbackSubmitted(properties: NbaFeedbackSubmittedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "3V8G_u4aEZTaB7jnof2UJ", name: "card_id", value: properties.cardId});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "dgKopHqafhYtQjJl3ViLB", name: "rating", value: properties.rating});
  eventPropertiesArray.push({id: "1NKzqn57q6h5IAfU_8Nz0", name: "feedback", value: properties.feedback});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_UHaNkJOxz5M_wphoRCyJ", "4e0f45cdd5e83ff71aaf2f2901f20428acb9662f77cb69f686b64f04ba2c60cb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("nba_feedback_submitted", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_UHaNkJOxz5M_wphoRCyJ", "nba_feedback_submitted", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("nba_feedback_submitted", eventProperties, "_UHaNkJOxz5M_wphoRCyJ", "4e0f45cdd5e83ff71aaf2f2901f20428acb9662f77cb69f686b64f04ba2c60cb");
    }
    // destination Segment
    Segment.logEvent("nba_feedback_submitted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ShowReturnLabelClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  orderId: string;
  userType: UserTypeValueType[];
  locationCode: string | null | undefined;
}
/**
 * show_return_label_clicked: Fired when a customer or style advisor clicks "Show return label" on a Return Registered Active Card in the Customer Hub.
 * Use for: measuring how often the return label is opened from Active Cards, split by user_type.
 * Do not fire when: the return label is opened from the Returns flow or Order details (see returning_item_show_qr_code_clicked).
 * 
 * When to trigger this event:
 * 1. a user clicks "Show return label" on a Return Registered active card
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/YjWS9DZ7otXxgokWsHb0D/trigger/tTBdC7W5_2ixkWeAWmS66
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.orderId: transaction id (native property of ecommerce object within Segment)
 * @param properties.userType: Describes whee
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/YjWS9DZ7otXxgokWsHb0D}
 */
export function showReturnLabelClicked(properties: ShowReturnLabelClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "9aTQ52H3v", name: "order_id", value: properties.orderId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: "active_card"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "YjWS9DZ7otXxgokWsHb0D", "4c0a643d7511e915eacd0a798f116fa5ee4b8720494b017202303ec8163ab35d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("show_return_label_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("YjWS9DZ7otXxgokWsHb0D", "show_return_label_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("show_return_label_clicked", eventProperties, "YjWS9DZ7otXxgokWsHb0D", "4c0a643d7511e915eacd0a798f116fa5ee4b8720494b017202303ec8163ab35d");
    }
    // destination Segment
    Segment.logEvent("show_return_label_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  CmLiteFit,
  MixAndMatch,
  Tab,
  ItemListName,
  AddressFields,
  LoggedIn,
  AddressType,
  LoginSource,
  EventCategory,
  Language,
  PageType,
  UserType,
  CmLiteVariantFit,
  Affiliation,
  Brand,
  Rating,
  Country,
  Currency,
  CardType,
  ApplicationId,
  productListViewed,
  productListViewedSimilarProducts,
  productListViewedNoSearchResultPage,
  productListViewedCustomMadeLite,
  productClicked,
  productClickedSimilarProducts,
  productClickedCustomMadeLite,
  productAddedToWishlist,
  productAddedToWishlistOutOfStock,
  productRemovedFromWishlist,
  faqOpen,
  customerInformationEdited,
  customerHubOpened,
  customerSelected,
  returnOrderClicked,
  customerAddressEdited,
  tabClicked,
  returnedToAcl,
  orderClicked,
  communicationPreferencesSaved,
  newArrivalsButtonClicked,
  settingsCustomerInfoClicked,
  settingsAddressBookClicked,
  settingsCommunicationClickled,
  cancellationClicked,
  cancellationApproved,
  cancellationConfirmed,
  trackYourOrderClicked,
  bookPickupAppointmentClicked,
  itemsInCartLoaded,
  wardrobeItemClicked,
  nbaCardViewed,
  nbaFeedbackSubmitted,
  showReturnLabelClicked,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["productListViewed","productListViewedSimilarProducts","productListViewedNoSearchResultPage","productListViewedCustomMadeLite","productClicked","productClickedSimilarProducts","productClickedCustomMadeLite","productAddedToWishlist","productAddedToWishlistOutOfStock","productRemovedFromWishlist","faqOpen","customerInformationEdited","customerHubOpened","customerSelected","returnOrderClicked","customerAddressEdited","tabClicked","returnedToAcl","orderClicked","communicationPreferencesSaved","newArrivalsButtonClicked","settingsCustomerInfoClicked","settingsAddressBookClicked","settingsCommunicationClickled","cancellationClicked","cancellationApproved","cancellationConfirmed","trackYourOrderClicked","bookPickupAppointmentClicked","itemsInCartLoaded","wardrobeItemClicked","nbaCardViewed","nbaFeedbackSubmitted","showReturnLabelClicked"]
